import { createContext, useContext } from "react";
import type { ActionResult, CompanyState } from "../types/company";
import type { Action } from "./company";

export interface CompanyContextValue {
  state: CompanyState;
  /** Applies a store action from lib/company and returns its result. */
  run: <A extends unknown[]>(action: Action<A>, ...args: A) => ActionResult;
  /** Same as `toast` from lib/toast: toast(msg), toast.success(msg), toast.error(err)… */
  toast: typeof import("./toast").toast;
}

export const CompanyContext = createContext<CompanyContextValue | null>(null);

export function useCompany(): CompanyContextValue {
  const value = useContext(CompanyContext);
  if (!value) throw new Error("useCompany must be used inside <CompanyProvider>");
  return value;
}
